import { MutationTree } from 'vuex';
import IFleetState from './types/IFleetState';
import IFleetMeta from './types/IFleetMeta';
import IFleetHeader from './types/IFleetHeader';
import IFleet from './types/IFleet';

const mutations: MutationTree<IFleetState> = {
  setMeta(state: IFleetState, meta: IFleetMeta) {
    state.meta = meta;
  },

  setHeader(state: IFleetState, header: IFleetHeader) {
    state.header = header;
  },

  setFleet(state: IFleetState, fleet: IFleet[]) {
    state.fleet = fleet;
  },
};

export default mutations;
